import React from 'react';
export function Fill({
  fillColor,
  strokeColor
}: {
  fillColor?: string;
  strokeColor?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none">
      <path d="M18.4572 13H3.6185C2.29975 13 1.34199 11.746 1.68897 10.4738L3.87079 2.47377C4.1081 1.60364 4.89842 1 5.80032 1H16.5178C17.4409 1 18.2441 1.63172 18.4615 2.5288L20.4009 10.5288C20.7061 11.7876 19.7525 13 18.4572 13Z" stroke={strokeColor ? strokeColor : 'currentColor'} strokeWidth="2" />
    </svg>;
}